<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">

                <b-form-row @keyup.enter="load">
                    <b-col lg="2" sm="12" class="text-left">
                    </b-col>
                    <b-col lg="8" sm="10" class="text-left mt-3">
                        <lg-form-input v-model="form.descricao" label=" " description=" " />
                    </b-col>
                    <b-col cols="2" class="text-right mt-2">
                        <b-button id="btnPesquisar" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="load">
                            <b-tooltip :target="'btnPesquisar'" title="Localizar"></b-tooltip>
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-card>

            <b-card bg-variant="light">
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :filter="filtro" :hover="true" show-empty @row-dblclicked="rowSelect">
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                    <template #empty>
                        <p>
                            Nenhum Registro encontrado
                        </p>
                    </template>

                    <template v-slot:cell(hierarquia)="row">
                        <b-button :id="row.index + 'filho-button'" class="my-2" size="sm" pill variant="primary"
                            @click="abrirModalFilho(row.item)">
                            <b-icon icon="list-nested" />
                            <b-tooltip :target="row.index + 'filho-button'"
                                title="Visualizar Hierarquias..."></b-tooltip>
                        </b-button>
                    </template>



                </b-table>

                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <ModalPageHierarquiaUnidadeAdministrativa v-if="mostrarHierarquia" @rowSelect="rowSelect" @close="fecharModalFilho"
            :prefix="prefix + title + ' > ' + sigla" :id="'hierarquia' + idFinderLocal" :idPai="idPai">
        </ModalPageHierarquiaUnidadeAdministrativa>


    </b-card>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { ListResourceMixin } from "@/core/mixins/resource"
import DepartamentoService from "@/core/api/DepartamentoService"
import ConfirmMixin from "@/core/mixins/confirm"
import ModalPageHierarquiaUnidadeAdministrativa from "@/core/components/Modals/ModalPageHierarquiaUnidadeAdministrativa.vue"

export default {
    name: "UnidadeAdministrativaList",

    components: {
        LgFormInput,
        ModalPageHierarquiaUnidadeAdministrativa
    },

    props: {
        idFinderLocal: {
            type: String,
            default: "",
        },
        onDblClickUnidadeAdministrativa: Function,
        prefix: { type: String, default: "" },
        title: {
            type: String,
            default: "Hierarquia Unidade Administrativa",
        },
        idPaiProp: { type: Number, default: null }
    },

    data() {
        return {
            sigla: '',
            idPai: this.idPaiProp,
            mostrarHierarquia: false,
            params: {},
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            showModal: false,
            records: [],
            form: {
                descricao: "",
            },
        }
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$DepartamentoService = new DepartamentoService()
    },

    mounted() {
        this.load()
    },

    watch: {
        page() {
            this.load()
        },
    },
    computed: {
        tableFields() {
            return [
                {
                    key: "sigla",
                    label: "Sigla",
                    thStyle: "font-size: 10px; font-weight: 400;",
                    tdStyle: "font-size: 10px",
                },
                {
                    key: "descricao",
                    label: "Unidades Administrativas",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "hierarquia",
                    label: " ",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
            ]
        },
    },

    methods: {
        rowSelect(item) {
            this.$emit("rowSelect", item)
        },
        fecharModalFilho() {
            this.idPai = null;
            this.sigla = '';
            this.mostrarHierarquia = false;
        },
        abrirModalFilho(departamento) {
            this.idPai = departamento.id;
            this.sigla = departamento.sigla;
            this.mostrarHierarquia = true;
        },
        async load() {
            this.busy = true
            await this.$DepartamentoService
                .findAllPai({
                    size: this.perPage,
                    page: this.page,
                    descricao: this.form.descricao,
                    idPai: this.idPai
                })
                .then(response => {
                    this.records = response.data.content
                    this.total = response.data.totalElements
                    this.totalPage = response.data.totalPages
                    this.busy = false
                })
                .finally(() => {
                    this.busy = false
                })
        },
        clearForm() {
            this.form.descricao = ""
            this.load()
        },

    },
}
</script>
